if (!customElements.get('gift-cta')) {
  class GiftCta extends HTMLElement {
    constructor() {
      super();
    }

    handleAddQuantityClick(event) {
      event.preventDefault();
      const $parent = event.target.closest('.js-quantity-alt');
      const $field = $parent.querySelector('.js-field');
      const $priceField = $parent.closest('.js-gift-cta').querySelector('.js-gift-total-price');
      const price = Number($priceField.getAttribute('data-price'));

      $field.value = (Number($field.value) + 1);
      $priceField.innerText = ('$' + (($field.value * price) / 100).toString().replace('.00', ''));
    }

    handleMinusQuantityClick(event) {
      event.preventDefault();

      const $parent = event.target.closest('.js-quantity-alt');
      const $field = $parent.querySelector('.js-field');
      const minValue = Number($field.getAttribute('min'));
      const $priceField = $parent.closest('.js-gift-cta').querySelector('.js-gift-total-price');
      const price = Number($priceField.getAttribute('data-price'));

      if (Number($field.value) === minValue) return;
      $field.value = (Number($field.value) - 1);
      $priceField.text('$' + (($field.value * price) / 100).toString().replace('.00', ''));
    }

    async fetchCart() {
      const response = await fetch('/cart.js');
      const json = await response.json();

      return json;
    }

    async handleSubmit(event) {
      event.preventDefault();
      const cartData = await this.fetchCart();
      let cartNote = cartData.note;

      const messageFrom = this.querySelector('#note-from');
      const messageTo = this.querySelector('#note-to');
      const messageNote = this.querySelector('#note');

      const $this = event.target;
      const $parent = $this.closest('.js-gift-cta');
      const $error = $parent.querySelector('.js-error');

      const variantId = $this.getAttribute('data-variant');
      const quantity = Number($parent.querySelector('.js-field')?.value);
      let formData = {}

      if (variantId && quantity) {
        formData.updates = {
          [`${variantId}`]: quantity,
        }
      }

      let orderNote = '';

      if (cartNote.includes('\r\nORDER NOTE:')) {
        orderNote = `\r\nORDER NOTE: ${cartNote.split('ORDER NOTE:')[1]}`;
      }

      let giftNote = ''

      if (messageFrom && messageFrom.value) {
        giftNote += 'From: ' + messageFrom.value + '|';
      }

      if (messageTo && messageTo.value) {
        giftNote += 'To: ' + messageTo.value + '|';
      }

      if (messageNote && messageNote.value) {
        giftNote += 'Message: ' + messageNote.value;
      }

      if (giftNote != '') {
        formData.note = giftNote + orderNote;
      }

      updateQuantity(formData);
      document.dispatchEvent(new CustomEvent('closeGiftDrawer'), {bubbles: true});
    }

    connectedCallback() {
      this.add = this.querySelector('.js-add');
      this.minus = this.querySelector('.js-minus');
      this.button = this.querySelector('.js-gift-submit')

      if(this.add) this.add.addEventListener('click', this.handleAddQuantityClick.bind(this));
      if(this.minus) this.minus.addEventListener('click', this.handleMinusQuantityClick.bind(this));
      if(this.button) this.button.addEventListener('click', this.handleSubmit.bind(this));
    }
  }
  customElements.define('gift-cta', GiftCta);
}
